/*
 * Copyright (c) Nexign, JSC, 2019-2022.
 */
/**
 *
 *
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.0.0
 */

import type { SagaIterator } from 'redux-saga';
import { call, put, select } from 'redux-saga/effects';

import { requestSaga } from '@/main/sagas/requestSaga';
import { API_HOSTNAME, BASKET_COUNT } from '@modules/app/Api';

import { getBasketCountFailed, getBasketCountSuccessful } from '../actions/tableActions';
import { makeSelectorTableCurrentName } from '../selectors/tableSelectors';
import { MapTableNameToBasketApiPath } from '../types/tableMapTypes';
import { TableNameType } from '../types/tableTypes';

export function* getBasketCountSaga(): SagaIterator {
    try {
        const tableName: TableNameType = yield select(makeSelectorTableCurrentName());
        const url = API_HOSTNAME + MapTableNameToBasketApiPath[tableName] + BASKET_COUNT;
        const { count } = yield call(requestSaga, url, 'GET');

        yield put(getBasketCountSuccessful(count));
    } catch (e: any) {
        yield put(getBasketCountFailed(e));
    }
}
